module.exports = __webpack_public_path__ + "static/media/verify-failure.9bf6ff46.svg";